import { useRouter } from 'next/router';
import tc from '@elem/compPage/CES2025/config/t&c';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const H = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('ces2025');

    const protocol = tc[locale] || tc['us'];

    const getContent = () => {
        let content = '';
        protocol.forEach((item: any) => {
            content = `${content}<p class="title">${item.title}</p>`;
            item.lines.forEach((v: string, index: number) => (content = `${content}<p key=${index} class="content">${v}</p>`));
        });
        return content;
    };

    return (
        <section className={styles.section}>
            <h5>{t('H_title')}</h5>
            <div className="text-container" dangerouslySetInnerHTML={{ __html: getContent() }}></div>
        </section>
    );
};

export default H;
